import React from 'react'
import styles from './context-menu.styles'
import injectSheet from 'react-jss'
import MoreButton from 'pobble-components/dist/more-button'
import DropMenu from 'pobble-components/dist/drop-menu'
import TrashIcon from 'react-icons/lib/fa/trash'
import PencilIcon from 'react-icons/lib/fa/pencil'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const ContextMenu = ({
  classes,
  body,
  onDelete,
  onOpenEditContributionDialog
}) => (
  <DropMenu
    button={({ ref, togglePopover }) => (
      <MoreButton forwardedRef={ref} onClick={togglePopover} />
    )}>
    {({ Menu, MenuItem, IconHolder, Separator, closePopover }) => (
      <Menu>
        <MenuItem
          onClick={() => {
            onOpenEditContributionDialog(body)
            closePopover()
          }}>
          <IconHolder>
            <PencilIcon />
          </IconHolder>
          Edit reply
        </MenuItem>
        <MenuItem
          onClick={() => {
            openConfirmationDialog({
              bodyText: 'Are you sure you want to delete this contribution?',
              action: onDelete,
              confirmText: 'Delete',
              cancelText: 'Cancel'
            })
            closePopover()
          }}>
          <IconHolder>
            <TrashIcon />
          </IconHolder>
          Delete
        </MenuItem>
      </Menu>
    )}
  </DropMenu>
)

export default injectSheet(styles)(ContextMenu)
